
document.querySelectorAll('accordion-disclosure').forEach((accordion) => {
  const details = accordion.querySelector('details');

  details.addEventListener('toggle', function () {
    if (this.open) {
      document.querySelectorAll('accordion-disclosure details[open]').forEach((other) => {
        if (other !== this) {
          other.removeAttribute('open');
          other.closest('accordion-disclosure').querySelector('details')
            .setAttribute('aria-expanded', 'false');
        }
      });

      this.setAttribute('aria-expanded', 'true');
    }
  });
});